var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEritrea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.609 14.6194C14.609 14.6194 4.6959 27.3267 4.68652 27.3244C7.5819 30.2198 11.582 32.0107 16.0003 32.0107C24.8368 32.0107 32.0003 24.8472 32.0003 16.0107L14.609 14.6194Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.609 16.0107C14.609 16.0107 4.6959 4.6948 4.68652 4.69705C7.5819 1.80162 11.582 0.0107422 16.0003 0.0107422C24.8368 0.0107422 32.0003 7.17424 32.0003 16.0107H14.609Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.69702C-1.56212 10.9454 -1.56212 21.0761 4.68625 27.3245C4.68581 27.3271 32 16.0108 32 16.0108L4.68625 4.69702Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34741 9.4021C5.27873 9.4021 2.78223 11.8987 2.78223 14.9673V17.0542C2.78223 20.1229 5.27879 22.6194 8.34741 22.6194C11.416 22.6194 13.9126 20.1229 13.9126 17.0542V14.9673C13.9127 11.8987 11.4161 9.4021 8.34741 9.4021ZM11.8257 17.0543C11.8257 18.6088 10.8005 19.9281 9.39085 20.3724V18.0978L10.8674 16.6213L9.39166 15.1456L9.39085 14.6204V13.9239H7.30398V16.0108L5.82848 17.4862L7.30398 18.9617V20.3725C5.89429 19.9282 4.86916 18.6088 4.86916 17.0543V14.9674C4.86916 13.0495 6.42954 11.4892 8.34741 11.4892C10.2653 11.4892 11.8257 13.0495 11.8257 14.9674V17.0543Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEritrea);
export default __webpack_public_path__ + "static/media/flag_eritrea.01033386928bde000ee7caf18113aafc.svg";
export { ForwardRef as ReactComponent };